import i18n from 'i18next'

const T_PREFIX = 'cycle_counts.errors'

// Every error_code CycleCountsController mints via `ExpectedError.new(message, code)`
// on the reassign/resolve/unassign paths. A code outside this set is either an
// uncoded server message or one we haven't mapped yet — it stays untranslated below.
const KNOWN_CODES = new Set(['REVIEWER_IS_COUNTER', 'THIRD_COUNT_REQUIRES_DISAGREEMENT', 'REVIEW_REASSIGNED', 'NOT_REVIEW_SUBMITTED', 'OPERATORS_DISABLED'])

// error_code is blank for errors the server never gave a code, but some of those
// still put "CODE: message" straight into `error` — recover the code from there so
// old and new server responses translate the same way.
const codeFromMessage = message => {
  const match = /^([A-Z][A-Z0-9_]*):/.exec(message || '')
  return match ? match[1] : null
}

// Only meant to run on a message the server declared a code for — an uncoded
// message can legitimately start with "WORD:" (a SKU, a warehouse code, …)
// and that qualifier must not be silently dropped.
export const stripCodePrefix = message => (message || '').replace(/^[A-Z][A-Z0-9_]*:\s*/, '')

// Localizes a server error for display. Falls back to the raw message when the
// code isn't one we have a translation for, stripping a "CODE:" prefix only
// when the server actually declared a code (via error_code, or a recognized
// prefix) — an uncoded message is shown untouched, prefix and all.
export const localizeReviewError = (message, errorCode, interpolation = {}) => {
  const code = errorCode || codeFromMessage(message)
  if (code && KNOWN_CODES.has(code)) {
    return i18n.t(`${T_PREFIX}.${code}`, interpolation)
  }
  return errorCode ? stripCodePrefix(message) : message || ''
}
